import React, { useState, useEffect } from "react";
import {
  Button,
  TextField,
  Typography,
  Paper,
  Box,
  MenuItem,
  Table,
  Modal,
  TableBody,
  InputAdornment,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  useMediaQuery,
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import DeleteIcon from "@mui/icons-material/Delete";
import Autocomplete from "@mui/material/Autocomplete";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import { Navigate, useNavigate } from "react-router-dom";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const convertFileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result.split(",")[1]);
    reader.onerror = (error) => reject(error);
    reader.readAsDataURL(file);
  });
};

const AddStockInward = () => {
  let navigate = useNavigate();
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [vendorId, setVendorId] = useState("");
  const [branchName, setBranchName] = useState([]);
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [branchId, setBranchId] = useState("");
  const [invoiceDate, setInvoiceDate] = useState(() => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  });
  const [receivedDate, setReceivedDate] = useState(() => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  });
  const [invoiceCopy, setInvoiceCopy] = useState(null);
  const [items, setItems] = useState([]);
  const [newItem, setNewItem] = useState({
    itemCode: "",
    quantity: "",
    unitCost: "",
    taxRate: "",
  });
  const [vendors, setVendors] = useState([]);
  const [branch, setBranch] = useState([""]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [inventoryItems, setInventoryItems] = useState([]);
  const [taxRates, setTaxRates] = useState([]);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");


  const isSmallScreen = useMediaQuery("(max-width:600px)");

  useEffect(() => {
    const fetchVendorData = async () => {
      if (branchId) {
        setIsLoading(true);
        await fetchVendors(branchId);
      }
    };
    fetchVendorData();
  }, [branchId]);

  useEffect(() => {
    if (branchId) {
      fetchInventoryItems(branchId);
    }
  }, [branchId]);

  useEffect(() => {
    fetchBranch();
  }, []);

  useEffect(() => {
    fetchTaxRates();
  }, []);

  useEffect(() => {
    fetchBranch();
  }, []);

 const fetchBranch = async () => {
  try {
    setIsLoading(true);
    const apiUrl = process.env.REACT_APP_BASE_URL;
    const response = await fetch(`${apiUrl}/Branch/GetBranch`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: sessionStorage.getItem("token"),
      },
      body: JSON.stringify({}),
    });
    if (response.ok) {
      const responseData = await response.json();
      setBranch(responseData || []);
      if (responseData.length > 0) {
        const defaultBranchId = String(responseData[0].branchId);
        setBranchId(defaultBranchId);
        fetchInventoryItems(defaultBranchId);
        fetchVendors(defaultBranchId);
      }
      setError("");
    } else {
      console.error("Failed to fetch branch:", response.status);
      setError("Failed to Load branch. Please try again.");
    }
  } catch (error) {
    console.error("Error fetching branch:", error);
    setError("An error occurred while loading branch.");
  } finally {
    setIsLoading(false);
  }
};

  const fetchVendors = async (branchId) => {
    try {
      setIsLoading(true);
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/Inventory/Vendor/GetVendors`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({ branchId }),
      });
      const responseData = await response.json();
      const allVendors = responseData.vendors || [];
      setVendors(allVendors);
      if (allVendors.length > 0) {
        setVendorId(String(allVendors[0].vendorID));
      } else {
        setVendorId("");
      }
      setError("");
    } catch (error) {
      console.error("Error fetching vendors:", error);
      setError("An error occurred while loading vendors.");
    } finally {
      setIsLoading(false);
    }
  };

const fetchInventoryItems = async (branchId) => {
  try {
    const apiUrl = process.env.REACT_APP_BASE_URL;
    const response = await fetch(
      `${apiUrl}/Inventory/Item/GetInventoryItems?itemId=0&Branch_Id=${branchId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: sessionStorage.getItem("token"),
        },
      }
    );
    if (response.ok) {
      const responseData = await response.json();
      setInventoryItems(responseData || []);
    } else {
      console.error("Failed to fetch inventory items:", response.status);
    }
  } catch (error) {
    console.error("Error fetching inventory items:", error);
  }
};

  const fetchTaxRates = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const response = await fetch(`${apiUrl}/Inventory/Item/GetTaxRates`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: sessionStorage.getItem("token"),
        },
      });
      if (response.ok) {
        const responseData = await response.json();
        setTaxRates(responseData.taxRates || []);
      } else {
        console.error("Failed to fetch tax rates:", response.status);
      }
    } catch (error) {
      console.error("Error fetching tax rates:", error);
    }
  };

  const handleAddItem = () => {
    if (
      newItem.itemId &&
      newItem.quantity > 0 &&
      newItem.unitCost >= 0
    ) {
      setItems([...items, newItem]);
      setNewItem({
        itemId: "",
        itemCode: "",
        itemName: "",
        unitCost: "",
        quantity: "",
        taxId: "",
        taxName: "",
      });
    } else {
      // alert("Please fill all item fields with valid values.");
      setSnackbarMessage('Please fill all item fields with valid values.');
      setOpenSnackbar(true);
      setSnackbarSeverity("warning")
    }
  };

  const handleDeleteItem = (index) => {
    const updatedItems = items.filter((_, i) => i !== index);
    setItems(updatedItems);
  };

  const handleReset = () => {
    setVendorId("");
    setInvoiceNumber("");
    setInvoiceDate("");
    setReceivedDate("");
    setInvoiceCopy(null);
    setItems([]);
    setNewItem({ itemCode: "", quantity: "", unitCost: "", taxRate: "" });
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    const isPDF = file.type === "application/pdf";
    const isImage = file.type.startsWith("image/");
    const maxPdfSize = 2 * 1024 * 1024;
    const maxImageSize = 200 * 1024;
    if (isPDF && file.size <= maxPdfSize) {
      setInvoiceCopy(file);
    } else if (isImage && file.size <= maxImageSize) {
      setInvoiceCopy(file);
    } else {
      // alert("Only PDF files up to 2MB or image files up to 200KB are allowed.");
      setSnackbarMessage('Only PDF files up to 2MB or image files up to 200KB are allowed.');
      setOpenSnackbar(true);
      setSnackbarSeverity("warning")
    }
  };

  const handleNumericInputChange = (field, value) => {
    if (value === "" || /^[0-9]*\.?[0-9]*$/.test(value)) {
      setNewItem({ ...newItem, [field]: value });
    }
  };

  const handleSave = async () => {
    if (!vendorId || !invoiceNumber || !invoiceDate || !receivedDate || items.length === 0) {
      // alert("Please fill all required fields and add at least one item.");
      setSnackbarMessage('Please fill all required fields and add at least one item.');
      setOpenSnackbar(true);
      setSnackbarSeverity("warning")
      return;
    }
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const formData = new FormData();
      formData.append("VendorID", vendorId);
      formData.append("InvoiceNumber", invoiceNumber);
      formData.append("InvoiceDate", invoiceDate);
      formData.append("ReceivedDate", receivedDate);
      if (invoiceCopy) {
        formData.append("InvoiceCopy", invoiceCopy);
        const base64String = await convertFileToBase64(invoiceCopy);
        formData.append("InvoiceCopyBase64", base64String);
      } else {
        formData.append("InvoiceCopyBase64", "");
      }

      const itemsData = items.map((item) => ({
        ItemID: item.itemId,
        QuantityReceived: parseInt(item.quantity, 10),
        UnitCost: parseFloat(item.unitCost),
        TaxId: parseFloat(item.taxId) || 0
      }));



      if (itemsData.length === 0) {
        console.error("Error: At least one item is required.");
        return;
      }

      itemsData.forEach((item, index) => {
        formData.append(`Items[${index}][itemID]`, item.ItemID);
        formData.append(`Items[${index}][quantityReceived]`, item.QuantityReceived);
        formData.append(`Items[${index}][UnitCost]`, item.UnitCost);
        formData.append(`Items[${index}][taxId]`, item.TaxId);
      });

     const response = await fetch(
  `${apiUrl}/Inventory/InwardItem/InsertStockInward?Branch_Id=${branchId}`,
  {
    method: "POST",
    headers: { Authorization: sessionStorage.getItem("token") },
    body: formData,
  }
);

      const responseData = await response.json();
      if (response.ok) {
        setShowSuccessModal(true);
        handleReset();
      } else {
        console.error("Failed to save stock inward:", response.status);
        // alert("Failed to save stock inward. Please try again.");
        setSnackbarMessage('Failed to save stock inward. Please try again.');
      setOpenSnackbar(true);
      setSnackbarSeverity("error")
      }
    } catch (error) {
      console.error("Error saving stock inward:", error);
      // alert("An error occurred while saving stock inward.");
      setSnackbarMessage('An error occurred while saving stock inward.');
      setOpenSnackbar(true);
      setSnackbarSeverity("error")
    }
  };

  const printReceipt = async () => {
    try {
      setIsLoading(true);
      const selectedBranch = branch.find(b => b.srBranchId === parseInt(branchId, 10));
      const selectedVendor = vendors.find(v => v.vendorID === parseInt(vendorId, 10));
      const header = {
        branchName: selectedBranch?.branchName || "Branch Name",
        branchID: branchId || "Branch ID",
        issuanceCode: items.itemCode,
        issuanceDate: new Date(receivedDate).toLocaleDateString(),
        issuedToName: selectedVendor?.vendorName || "Vendor Name",
        issuedToType: "Vendor",
        issuedToID: vendorId || "Vendor ID",
        totalQuantity: items.reduce((sum, item) => sum + parseInt(item.quantity || 0, 10), 0),
        createdByName: "Current User",
        createdBy: "User ID",
        createdDate: new Date().toLocaleDateString()
      };

      const details = items.map(item => {
        const itemDetails = inventoryItems.find(i => i.itemId === item.itemCode);
        return {
          itemCode: itemDetails?.itemCode || items.itemCode,
          itemName: itemDetails?.itemName || "Item",
          quantityIssued: item.quantity
        };
      });

      const receiptDiv = document.createElement("div");
      receiptDiv.style.position = "absolute";
      receiptDiv.style.left = "-9999px";
      receiptDiv.style.width = "816px";
      receiptDiv.innerHTML = `
        <!DOCTYPE html>
        <html>
        <head>
          <title>Stock Inward Receipt</title>
          <script src="https://cdn.tailwindcss.com"></script>
          <style>
            body { margin: 0; font-family: Arial, sans-serif; }
            .logo-placeholder { width: 80px; height: 80px; background: #e5e7eb; }
          </style>
        </head>
        <body class="font-sans bg-gray-100">
          <div class="max-w-3xl mx-auto bg-white p-8 my-8 rounded-lg shadow-lg">
            <div class="flex items-center justify-between mb-6">
              <div class="flex items-center">
                <div class="logo-placeholder rounded-full mr-4"></div>
                <div>
                  <h1 class="text-2xl font-bold text-blue-600">${header.branchName}</h1>
                  <p class="text-sm text-gray-600">Stock Inward Receipt</p>
                </div>
              </div>
              <div class="text-right">
                <p>Date: ${header.issuanceDate}</p>
              </div>
            </div>
            <hr class="border-gray-300 mb-6">
            <div class="grid grid-cols-2 gap-4 mb-6">
              <div>
                <p class="font-semibold">Issued To:</p>
                <p>${header.issuedToName} (${header.issuedToType})</p>
                <p>ID: ${header.issuedToID}</p>
              </div>
              <div>
                <p class="font-semibold">Branch:</p>
                <p>${header.branchName}</p>
                <p>Branch ID: ${header.branchID}</p>
              </div>
            </div>
            <table class="w-full border-collapse mb-6">
              <thead>
                <tr class="bg-blue-600 text-white">
                  <th class="border border-gray-300 p-3 text-left">Item Code</th>
                  <th class="border border-gray-300 p-3 text-left">Item Name</th>
                  <th class="border border-gray-300 p-3 text-right">Quantity Issued</th>
                </tr>
              </thead>
              <tbody>
                ${details.map(item => `
                  <tr class="hover:bg-gray-50">
                    <td class="border border-gray-300 p-3">${item.itemCode}</td>
                    <td class="border border-gray-300 p-3">${item.itemName}</td>
                    <td class="border border-gray-300 p-3 text-right">${item.quantityIssued}</td>
                  </tr>
                `).join("")}
              </tbody>
            </table>
            <div class="flex justify-end mb-6">
              <div class="text-right">
                <p class="font-semibold">Total Quantity: <span class="text-blue-600">${header.totalQuantity}</span></p>
              </div>
            </div>
            <div class="mb-6">
              <p class="font-semibold">Created By:</p>
              <p>Created Date: ${header.createdDate}</p>
            </div>
            <hr class="border-gray-300 mb-6">
            <div class="grid grid-cols-2 gap-4 mb-6">
              <div>
                <p class="font-semibold">Authorized Signature:</p>
                <div class="h-12 border-b border-gray-300 w-48 mt-2"></div>
              </div>
              <div class="text-right">
                <p class="font-semibold">Terms:</p>
                <p class="text-sm text-gray-600">Items issued are non-returnable unless authorized.</p>
              </div>
            </div>
          </div>
        </body>
        </html>
      `;
      document.body.appendChild(receiptDiv);
      await new Promise((resolve) => setTimeout(resolve, 500));
      const canvas = await html2canvas(receiptDiv, {
        scale: 2,
        useCORS: true,
        logging: false,
      });
      document.body.removeChild(receiptDiv);
      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
      });
      const imgData = canvas.toDataURL("image/png");
      const imgWidth = 210;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
      const pdfBlob = pdf.output("blob");
      const pdfUrl = URL.createObjectURL(pdfBlob);
      const pdfWindow = window.open(pdfUrl, "_blank");
      if (pdfWindow) {
        pdfWindow.onload = () => {
          pdfWindow.print();
        };
      } else {
        setSnackbarMessage("Please allow popups to view the PDF receipt");
        setOpenSnackbar(true);
        setSnackbarSeverity("warning");
      }
    } catch (error) {
      console.error("Error in printReceipt:", error);
      setSnackbarMessage("Failed to generate PDF receipt");
      setOpenSnackbar(true);
      setSnackbarSeverity("error");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="container ">
      <Typography
        variant="h4"
        gutterBottom
        sx={{
          backgroundColor: "#0B1F40",
          color: "#fff",
          padding: "12px 20px",

          fontWeight: "bold",

          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          mb: 1,
        }}
      >
        Stock Inward Form
      </Typography>
      <Paper elevation={3} style={{ padding: 16, marginTop: 6 }}>

        <Box
          sx={{
            width: "100%",
            maxWidth: "100%",
            margin: "10px auto",
            padding: "32px",
            backgroundColor: "#ffffff",
            borderRadius: "12px",
            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
          }}
        >
          <div
            className="row"
            style={{
              display: "flex",
              flexWrap: "wrap",
              rowGap: "0px",
              columnGap: "55px",
              justifyContent: "center",
            }}
          >
           <div className="col-md-5">
  <Typography variant="subtitle1" gutterBottom>
    Branch Name <span style={{ color: "red" }}>*</span>
  </Typography>
  <TextField
    select
    fullWidth
    variant="outlined"
    value={branchId}
    onChange={(e) => setBranchId(e.target.value)}
    sx={{ backgroundColor: "#f9f9f9", borderRadius: "4px" }}
  >
    <MenuItem value="" disabled>
      --Select Branch--
    </MenuItem>
    {branch.map((b) => (
      <MenuItem key={b.branchId} value={b.branchId}>
        {b.branchName}
      </MenuItem>
    ))}
  </TextField>
</div>
            <div className="col-md-5">
              <Typography variant="subtitle1" gutterBottom>
                Vendor Name <span style={{ color: "red" }}>*</span>
              </Typography>
              <TextField
                select
                fullWidth
                variant="outlined"
                value={vendorId}
                onChange={(e) => setVendorId(e.target.value)}
                sx={{ backgroundColor: "#f9f9f9", borderRadius: "4px" }}
              >
                <MenuItem value="" disabled>
                  --Select Vendor--
                </MenuItem>
                {vendors.map((vendor) => (
                  <MenuItem key={vendor.vendorID} value={vendor.vendorID}>
                    {vendor.vendorName}
                  </MenuItem>
                ))}
              </TextField>
            </div>
            <div className="col-md-5">
              <Typography variant="subtitle1" gutterBottom>
                Invoice Number <span style={{ color: "red" }}>*</span>
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                value={invoiceNumber}
                onChange={(e) => setInvoiceNumber(e.target.value)}
                placeholder="Enter Invoice Number"
                sx={{ backgroundColor: "#f9f9f9", borderRadius: "4px" }}
              />
            </div>
            <div className="col-md-5">
              <Typography variant="subtitle1" gutterBottom>
                Invoice Date <span style={{ color: "red" }}>*</span>
              </Typography>
              <input
                type="date"
                value={invoiceDate}
                onChange={(e) => setInvoiceDate(e.target.value)}
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "4px",
                  border: "1px solid #ccc",
                  backgroundColor: "#f9f9f9",
                }}
              />
            </div>
            <div className="col-md-5">
              <Typography variant="subtitle1" gutterBottom>
                Invoice Copy <span style={{ color: "red" }}>*</span>
              </Typography>
              <input
                type="file"
                onChange={handleFileUpload}
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "4px",
                  border: "1px solid #ccc",
                  backgroundColor: "#f9f9f9",
                }}
              />
            </div>
            <div className="col-md-5">
              <Typography variant="subtitle1" gutterBottom>
                Received Date <span style={{ color: "red" }}>*</span>
              </Typography>
              <input
                type="date"
                value={receivedDate}
                onChange={(e) => setReceivedDate(e.target.value)}
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "4px",
                  border: "1px solid #ccc",
                  backgroundColor: "#f9f9f9",
                }}
              />
            </div>
          </div>
        </Box>
        <Typography variant="h5" gutterBottom style={{ marginTop: "16px", marginLeft: "15px", paddingLeft: "0px" }}>
          Items Table
        </Typography>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Item Name</TableCell>
                <TableCell>Quantity Received</TableCell>
                <TableCell>Unit Cost</TableCell>
                <TableCell>Tax Rate (%)</TableCell>
                <TableCell>Amount</TableCell>
                <TableCell>Tax Amount</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {items.map((item, index) => (
                <TableRow key={index}>
                  <TableCell>{item.itemName}</TableCell>
                  <TableCell>{item.quantity}</TableCell>
                  <TableCell>{item.unitCost}</TableCell>
                  <TableCell>{item.taxName ?? 0}</TableCell>
                  <TableCell>{(item.quantity * item.unitCost).toFixed(2)}</TableCell>
                  <TableCell>
                    {((item.quantity * item.unitCost * item.taxName) / 100).toFixed(2)}
                  </TableCell>
                  <TableCell>
                    <IconButton onClick={() => handleDeleteItem(index)}>
                      <DeleteIcon color="error" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
              <TableRow>
                <TableCell>
                  <Autocomplete
                    options={inventoryItems}
                    getOptionLabel={(option) => `${option.itemCode} - ${option.itemName}`}
                    value={inventoryItems.find(item => item.itemId === newItem.itemId) || null}
                    onChange={(event, newValue) => {
                      setNewItem({
                        itemId: newValue?.itemId || "",
                        itemCode: newValue?.itemCode || "",
                        itemName: newValue?.itemName || "",
                        unitCost: newValue?.purchasedPrice || 0,
                        quantity: "",
                        taxId: newValue?.taxId || 0,
                        taxName: newValue?.taxName || 0, //changed taxname to 0 if not present
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        placeholder="Search Item"
                        sx={{ width: '300px' }} // Set a fixed width for the dropdown
                      />
                    )}
                    sx={{ width: '300px' }} // Set the same fixed width for the Autocomplete component
                  />
                </TableCell>

                <TableCell>
                  <TextField
                    fullWidth
                    type="number"
                    variant="outlined"
                    value={newItem.quantity}
                    onChange={(e) =>
                      handleNumericInputChange("quantity", e.target.value)
                    }
                    placeholder="Quantity"
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    fullWidth
                    type="text"
                    variant="outlined"
                    value={newItem.unitCost ?? 0}
                    onChange={(e) =>
                      handleNumericInputChange("unitCost", e.target.value)
                    }
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    fullWidth
                    variant="outlined"
                    label="Tax (%)"
                    value={newItem.taxName ?? 0}
                    InputProps={{
                      readOnly: true,
                      endAdornment: <InputAdornment position="end">%</InputAdornment>,
                    }}
                  />
                </TableCell>
                <TableCell colSpan={2}></TableCell>
                <TableCell>
                  <IconButton onClick={handleAddItem}>
                    <AddCircleOutlineIcon color="primary" />
                  </IconButton>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "16px",
            gap: "14px",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            sx={{
              width: "80px",
              height: "50px",
              padding: "10px 0",
              fontWeight: 'bold'
            }}
            onClick={handleSave}
          >
            SAVE
          </Button>
          <Button
            variant="contained"
            color="error"
            sx={{
              width: "80px",
              height: "50px",
              padding: "10px 0",
              fontWeight: 'bold'
            }}
            onClick={handleReset}
          >
            RESET
          </Button>
        </div>
      </Paper>

      <Modal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        aria-labelledby="success-modal-title"
        aria-describedby="success-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          {/* Header */}
          <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
            <Typography id="success-modal-title" variant="h6" sx={{ color: '#fff' }}>
              Stock Inward Added ✅
            </Typography>
          </Box>

          {/* Content */}
          <Box sx={{ padding: '20px' }}>
            <Typography id="success-modal-description" sx={{ mb: 2 }}>
              Stock Inward has been added successfully.
            </Typography>

            {/* Buttons */}
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setShowSuccessModal(false);
                  navigate(-1); // go back after closing modal
                }}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
<Snackbar
  open={openSnackbar}
  autoHideDuration={4000}
  onClose={() => setOpenSnackbar(false)}
  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
>
  <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
    {snackbarMessage}
  </Alert>
</Snackbar>

    </div>
  );
};

export default AddStockInward;
 